import { ViewType } from 'owa-calendar-actions';
import { canRemove, isSeriesInstance } from 'owa-calendar-event-capabilities';
import { deleteCalendarEvent } from 'owa-calendar-events-actions';
import { CalendarEvent } from 'owa-calendar-types';
import { ControlIcons } from 'owa-control-icons';
import { getRemoveFromCalendarCaption } from 'owa-event-context-menu';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import EventScope from 'owa-service/lib/contract/EventScope';

/**
 * Returns the button for remove
 * @param event Calendar event
 * @param actionSource Calendar view
 * @param onRemoveClicked remove callback
 */
export const getRemoveButton = (
    event: CalendarEvent,
    actionSource: ViewType,
    onRemoveClicked?: () => void
): FilterableMenuItem => {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: getRemoveFromCalendarCaption(
            isSeriesInstance(event),
            event.IsSeriesCancelled
        ),
        [FilterableMenuItemArgs.icon]: ControlIcons.RemoveEvent,
        [FilterableMenuItemArgs.onClick]: () =>
            deleteCalendarEvent(
                event,
                actionSource,
                event.IsSeriesCancelled ? EventScope.AllInstancesInSeries : EventScope.Default,
                onRemoveClicked
            ),
        [FilterableMenuItemArgs.shouldShow]: () => canRemove(event),
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.key]: 'Remove',
    });
};
